module.exports = __webpack_public_path__ + "static/media/__tickets.b5ffe5bc.svg";